<template>
  <div class="wrapper">
    <iframe :src="url"
            id="scanner"
            frameborder="0"
            scrolling="auto"
            allow="camera">
    </iframe>
  </div>
</template>

<script>
import { isEmpty } from 'lodash';
import getSettings from '../config';
import {
  parseFromQuerystring,
  PostMessageBus,
  Runner,
  serializeToQuerystring,
} from '../utility';

export default {
  name: 'TicketScanner',
  data() {
    return {
      runner: {},
      postMessageBus: {},
    };
  },
  computed: {
    url() {
      const params = {
        ...getSettings(),
        qs: this.urlParams,
        nativeMode: this.runner.isValid(),
      };

      if (!isEmpty(this.urlParams)) params.qs = this.urlParams;

      return `${process.env.VUE_APP_IFRAME_URL}/?${serializeToQuerystring(params)}`;
    },
    urlParams() {
      return parseFromQuerystring(window.location.search);
    },
  },
  methods: {
    init() {
      this.runner = new Runner();
      this.postMessageBus = new PostMessageBus({
        url: process.env.VUE_APP_IFRAME_URL,
        elementId: 'scanner',
      });

      this.runner.setListener(this.handleRunnerMessage);
      this.postMessageBus.setListener(this.handlePostMessage);
    },
    handleRunnerMessage(data) {
      this.postMessageBus.sendMessage(data);
    },
    handlePostMessage(data) {
      this.runner.sendMessage(data);
    },
  },
  beforeMount() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.wrapper {
  position: absolute;
  margin: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  iframe {
    height: 100%;
    width: 100%;
    display: block;
  }
}
</style>
